import { connect } from 'react-redux';
import ReturnOrderPage from './ReturnOrderPage';
import { Dispatch, AnyAction } from 'redux';
import { AppState } from '../../redux';
import { rowClick, getManufactureOrderData, approvalRequired, rework } from 'src/actions/liveOrderAction';
import { downloadURL, onbulkDownload, onBulkDownloadStl } from 'src/actions/completeOrderAction';
import { doCheckAuthentication } from 'src/actions/aunthenticateAction';
import { openVideoPlayerURLArray } from 'src/actions/landingPageAction';
import { RowDataCompleted } from 'src/reducers/completeorderfile';
import { SHOW_FAILED_FILES_DIALOG } from '../../reducers/completeorderfile';

export const mapStateToProps = (state: AppState) => {
    return {
        liveOrderDataReturned: state.liveOrder.liveOrderDataReturned,
        orderDataTat: state.fileUpload.orderDataTat,
        orderDataManufacturer: state.fileUpload.orderDataManufacturer,
        isDownloading: state.completeOrder.isDownloading,
        redesignReasons: state.completeOrder.redesignReasons,
         // New properties for failed files dialog
         failedFiles: state.completeOrder.failedFiles,
         showFailedFilesDialog: state.completeOrder.showFailedFilesDialog,
         failedFilesMessage: state.completeOrder.failedFilesMessage,
    };
};

export const mapDispatchToProps = (dispatch: Dispatch<AppState>) => {
    return {
        onComponentDidMount: () => {
            // dispatch(getManufactureOrderData);
            // dispatch(getRedesignReasons);
        },
        onComponentWillMount: () => {
            dispatch(doCheckAuthentication);
            dispatch(getManufactureOrderData);
        },
        reload: () => {
            dispatch(getManufactureOrderData);
        },
        approvalRequired: (array: Array<object>) => {
            dispatch(approvalRequired(array));
        },
        onRowClick: (orderid: string, rowData: string) => {
            dispatch(rowClick(orderid, rowData));
        },
        onDownloadClick: (filepath: string, fileName: string) => {
            dispatch(downloadURL(filepath, fileName, 'Initial Scan'));
        },
        redesignRequest: (columns: Object) => {
            dispatch(rework(columns, 'return'));
        },
        onBulkDownload: (completedData: RowDataCompleted[] | RowDataCompleted) => {
            dispatch(onbulkDownload(completedData, true));
        },
        onBulkDownloadStl: (completedData: RowDataCompleted[] | RowDataCompleted, filetype: string) => {
            dispatch(onBulkDownloadStl(completedData, filetype, true));
        },
        openVideoPlayerURL: (fullPath: string[], fpath: string) => {
            dispatch(openVideoPlayerURLArray(fullPath, fpath));
        },
         closeFailedFilesDialog: () => {
        dispatch({ type: SHOW_FAILED_FILES_DIALOG, showFailedFilesDialog: false } as AnyAction);
        },
    };
};

const LiveOrderContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
)(ReturnOrderPage);

export default LiveOrderContainer;



// WEBPACK FOOTER //
// ./src/components/ReturnOrderPage/ReturnOrderPageContainer.tsx